import AdminBreadCrumb from "../components/AdminBreadCrumb";
import AdminLayout from "../components/AdminLayout"
import $ from 'jquery';
import { useState, useEffect } from "react";
const Orders = () => {
    const orderData = [
        {
            _id: 1,
            "FirstName": "John",
            "LastName": "Doe",
            "Email": "johndoe@example.com",
            "PhoneCode": "+91",
            "Phone": "787912356",
            "Message": "Good Excellent"
        }
    ]
    const itemsPerPage = 20;
    const [currentPage, setCurrentPage] = useState(1);
    const [btndisable, setBtndisable] = useState(true);
    const totalPages = Math.ceil(orderData.length / itemsPerPage);
    const handleFirst = () => setCurrentPage(1);
    const handlePrev = () => setCurrentPage(prev => Math.max(prev - 1, 1));
    const handleNext = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
    const handleLast = () => setCurrentPage(totalPages);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const currentPageData = orderData.slice(startIdx, startIdx + itemsPerPage);
    useEffect(() => {
        $("#selectAll").on("change", function () {
            const isChecked = $(this).prop("checked");
            $(".admin-table tbody input[type=checkbox]").prop("checked", isChecked);
            setBtndisable(!isChecked);
        });
        $(".admin-table tbody input[type=checkbox]").on("change", function () {
            if (!$(this).prop("checked")) {
                $("#selectAll").prop("checked", false);
                if (!$(".admin-table tbody input[type=checkbox]").is(":checked")) {
                    setBtndisable(true);
                }
            } else {
                setBtndisable(false);
            }
        });
        var pageh = $(window).height();
        var ex = 65 + 49 + 100 + 38 + 16;
        var total = pageh - ex;
        $(".scroll").height(total + "px");
    }, []);
    return (
        <AdminLayout>
            <AdminBreadCrumb title="Orders"/>
            <div className="main-layout">
                <div className="container-fluid">
                    {
                        orderData.length !== 0 ? 
                        <>
                        <div className="table-responsive scroll">
                            <table className="table table-hover table-striped admin-table registration-table">
                                <thead>
                                    <tr>
                                        <th>Sl No</th>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <input type="checkbox" id="selectAll"/>
                                                <div class="dropdown">
                                                    <button class="btn p-0" style={{ position: "relative", top: "2px", color: "#fff", border: "none" }} type="button" data-bs-toggle="dropdown" aria-expanded="false" disabled={btndisable ? true : false}>
                                                        <i className='bx bx-chevron-down' ></i>
                                                    </button>
                                                    <ul class="dropdown-menu">
                                                        <li><button class="dropdown-item" type="button" data-bs-toggle="modal" data-bs-target="#bulkdeleteModal">Bulk Delete</button></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </th>
                                        <th>Actions</th>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentPageData.map((el, index) => {
                                            return (
                                                <tr key={el._id}>
                                                    <td>{startIdx + index + 1}</td>
                                                    <td><input type="checkbox" id={`user${el._id}`}/></td>
                                                    <td>
                                                        <div className="d-flex gap-1">
                                                            <button className="btn btn-danger" type="button" data-bs-toggle="modal" data-bs-target="#deleteRegistrationModal"><i className='bx bxs-trash'></i></button>
                                                        </div>
                                                    </td>
                                                    <td>{el._id}</td>
                                                    <td>{el.FirstName} {el.LastName}</td>
                                                    <td>{el.Email}</td>
                                                    <td>{el.PhoneCode} {el.Phone}</td>
                                                    <td>{el.Message}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        {
                            orderData.length !== 0 ? 
                            <nav aria-label="...">
                            <ul class="pagination mb-0 mt-3 justify-content-end">
                                {
                                    currentPage > 1 && (
                                        <>
                                            <li class="page-item">
                                                <button class="page-link" onClick={handleFirst}>First</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link" onClick={handlePrev}>Previous</button>
                                            </li>
                                        </>
                                    )
                                }
                                {
                                    Array.from({ length: totalPages }, (_, index) => (
                                        <li class={`page-item ${currentPage === index + 1 ? "active": ""}`} key={index}>
                                            <button class="page-link" onClick={() => setCurrentPage(index + 1)}>{index + 1}</button>
                                        </li>
                                    ))
                                }
                                {
                                    currentPage < totalPages && (
                                        <>
                                            <li class="page-item">
                                                <button class="page-link" onClick={handleNext}>Next</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link" onClick={handleLast}>Last</button>
                                            </li>
                                        </>
                                    )
                                }
                            </ul>
                        </nav> : ""
                        }
                        </>
                    :
                    <p className="mb-0">No Results Found!</p>
                    }
                </div>
            </div>
            <div class="modal fade text-black" id="deleteRegistrationModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Delete User</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            Are you sure to delete the user ?
                        </div>
                        <div class="modal-footer" style={{ flexWrap: "nowrap" }}>
                            <button type="button" class="btn btn-default" style={{ width: "50%" }} data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger" style={{ width: "50%" }}>Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade text-black" id="bulkdeleteModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Bulk Delete Users</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            Are you sure to bulk delete the users ?
                        </div>
                        <div class="modal-footer" style={{ flexWrap: "nowrap" }}>
                            <button type="button" class="btn btn-default" style={{ width: "50%" }} data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger" style={{ width: "50%" }}>Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    )
}

export default Orders;